<template>
  <svg class="xds:icon" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.5 1.5H3.5V3.5H1.5V1.5ZM1.5 4.5H3.5V6.5H1.5V4.5ZM4.5 1.5H6.5V3.5H4.5V1.5ZM4.5 4.5H6.5V6.5H4.5V4.5Z"
      stroke="currentColor"
      stroke-width="0.4"
      stroke-linejoin="round"
    />
  </svg>
</template>
